import { BaseModel } from "@Core";

export enum DayLight {
    Disabled,
    Automatic
}

export enum TimeType {
    NTP,
    Computer,
    Manual,
}

export enum NtpSyncEnable {
    Disable,
    Enable,
}

export enum NtpInterval {
    OneHour = 60,
    TwoHours = 120,
    FiveHours = 300,
    TenHours = 600,
    OneDay = 1440,
    TwoDays = 2880,
    FiveDays = 7200,
    TenDays = 14400,
    ThirtyDays = 43200,
}

export interface SP111SysDateTime extends BaseModel{
    DevMac: string;
    Year: number;
    Month: number;
    Day: number;
    Hour: number;
    Minute: number;
    Second: number;
    TimeZoneTz: string; 
    ZoneNameTz: string; 
    DayLight: DayLight; 
    TimeType: TimeType; 
    NtpServer: string;
    NtpSyncEnable: NtpSyncEnable; 
    NtpInterval: NtpInterval; 
}

